import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';
import { reload } from 'webapp/utils/common';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class CommonPopupReloadModalComponent extends PopupInnerModalComponent<PopupData.Common.ReloadModal> {
	@service('account') declare accountService: Service.Account;
	@service('analytics') declare analyticsService: Service.Analytics;

	@tracked reloadInProgress = false;

	get changesText() {
		return this.popupData.changesText;
	}

	get fromVersionChecker() {
		return this.popupData.fromVersionChecker;
	}

	get companyName() {
		return this.accountService.shownCompanyName;
	}

	@action
	reload() {
		if (this.reloadInProgress) {
			return;
		}
		this.reloadInProgress = true;

		if (this.fromVersionChecker) {
			this.analyticsService.event(TrackingEvent.RELOADED_AFTER_UPDATE);
		}
		later(reload, 100); // so the event can get triggered reliably
	}
	<template>
		<div class="content">
			<CommonUiIconComponent @name="Refresh" @size="2xl" />
			<h3>{{this.companyName}} needs to be reloaded</h3>
			<p>
				<strong>
					While you were using
					{{this.companyName}}, we updated the web application.
				</strong>
				<br />
				These changes will take place after you reload your browser window.
				{{#if this.changesText}}
					<br />
					{{{this.changesText}}}
				{{/if}}
			</p>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Reload"
						@onTrigger={{this.reload}}
						@submitInProgress={{this.reloadInProgress}}
					/>
				</div>
			</div>
		</div>
	</template>
}
